import { AutoComplete, Button, Form, Input, Radio, Row, Select, SelectProps, Spin } from "antd";
import validateMessages from "../../utils/validate";
import Password from "antd/es/input/Password";
import { CheckOutlined, LockOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import Icon from "../../components/Icon";
import ROUTES from "../../routes";
import Notification from "../../components/Notification";
import { useGetOrganizationsQuery, useLazyGetOrganizationsQuery, useRegisterServiceCenterMutation, useRegisterServiceTakerMutation } from "../../services/auth";
import { useCallback, useEffect, useState } from "react";
import { useGetBusinessTypesQuery } from "../../services/misc";
import debounce from "lodash.debounce";
import useScreenSize from "../../hooks/useScreenSize";

const Register = () => {
    const navigate = useNavigate();
    const { isMobile } = useScreenSize();
    const [registerForm] = Form.useForm();
    const [registerServiceCenter, registerCenterResult] = useRegisterServiceCenterMutation();
    const [registerServiceTaker, registerTakerResult] = useRegisterServiceTakerMutation();
    const password = Form.useWatch("password", registerForm);
    const [regType, setRegType] = useState<string>("service-center");
    const [businessTypeId, setBusinessTypeId] = useState<number | null>(null);
    const validateConfirmPassword = (rule: any, value: string) => {
        if (value && password) {
            if (value === password) {
                return Promise.resolve();
            }
            return Promise.reject(new Error("Passwords don't match"));
        }
        return Promise.resolve();
    };
    const [businessTypes, setBusinessTypes] = useState<any[]>([]);
    const {
        data: getBusinessTypesResponse,
        isFetching: isBusinessTypesFetching,
        isSuccess: isBusinessTypesSuccess,
    } = useGetBusinessTypesQuery({});

    useEffect(() => {
        if (isBusinessTypesSuccess) {
            const businessTypeList = getBusinessTypesResponse || [];
            setBusinessTypes(businessTypeList);
        }
    }, [isBusinessTypesFetching]);

    const onBack = () => {
        navigate(ROUTES.PATHS.LOGIN);
    };
    const handleRegister = async () => {
        try {
            await registerForm.validateFields();
        } catch (errorInfo) {
            return;
        }

        const formFields = registerForm.getFieldsValue();
        if (formFields.regType === "service-center") {
            const payload = {
                name: formFields.name,
                addressLine1: formFields.addressLine1,
                addressLine2: formFields.addressLine2,
                contactName: formFields.contactName,
                email: formFields.email,
                phone: formFields.phone,
                organizationName: formFields.organizationName,
                businessTypeId: formFields.businessTypeId,
                loginName: formFields.loginName,
                password: formFields.password
            };
            try {
                await registerServiceCenter(payload).unwrap();
                Notification({
                    type: "success",
                    title: "Registration",
                    description: "You are successfully registered. Please try to login now.",
                    placement: "top"
                });
                navigate(ROUTES.PATHS.LOGIN);
            } catch (e) { }
        } else {
            const payload = {
                name: formFields.name,
                email: formFields.email,
                phone: formFields.phone,
                gender: formFields.gender,
                loginName: formFields.loginName,
                password: formFields.password
            };
            try {
                await registerServiceTaker(payload).unwrap();
                Notification({
                    type: "success",
                    title: "Registration",
                    description: "You are successfully registered. Please try to login now.",
                    placement: "top"
                });
                navigate(ROUTES.PATHS.LOGIN);
            } catch (e) { }
        }
    };

    const requiredRule = { required: true, message: "Required" };
    const [searchTerm, setSearchTerm] = useState("");
    const handleSearch = (value: string) => {
        setSearchTerm(value);
    };
    const debouncedSearch = useCallback(
        debounce((value: string) => {
            handleSearch(value);
        }, 300),
        []
    );

    const {
        data: orgsResponse,
        isFetching: orgsFetching,
        isSuccess: orgsSuccess,
    } = useGetOrganizationsQuery({ srcText: searchTerm });

    /*
    let timeout: ReturnType<typeof setTimeout> | null;
    let currentValue: string;
    const [companies, setCompanies] = useState<SelectProps['options']>([]);
    const [getCompanies, getCompaniesResult] = useLazyGetOrganizationsQuery();
    const fetchData = (value: string, callback: (data: { value: string; text: string }[]) => void) => {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        currentValue = value;


        const getApiData = () => {
            getCompanies({ srcText: value }).unwrap()
                // fetch(`https://suggest.taobao.com/sug?${params.toString()}`)
                // .then((response) => response.json())
                .then((result) => {
                    if (currentValue === value) {
                        const data = result.map((item: any) => ({ value: item.name, text: item.name }));
                        callback(data);
                    }
                });
        };
        if (value) {
            timeout = setTimeout(getApiData, 300);
        } else {
            callback([]);
        }
    };
    const handleSearchCompanies = (newValue: string) => {
        fetchData(newValue, setCompanies);
    };
*/
    return (
        <div className="bg-idp-illustration bg-no-repeat bg-center grid place-content-center space-y-20">
            <div className="w-[80vw] space-y-[10px]" style={{ maxWidth: isMobile ? "400px" : "800px" }}>
                <Form
                    form={registerForm}
                    layout="vertical"
                    name="registerForm"
                    validateMessages={validateMessages}
                >
                    <div className="mb-5 mt-5">
                        <div>
                            <h2 className="mt-0 text-primary"><Icon
                                icon="arrow_back"
                                className="h-5 w-5 cursor-pointer mr-1"
                                onClick={onBack}
                            />
                                Registration
                            </h2>
                        </div>
                        {/* <Form.Item name="company" label={<>Company</>} >
                            <Select
                                showSearch
                                // value={value}
                                placeholder={"Search company"}
                                defaultActiveFirstOption={false}
                                suffixIcon={null}
                                filterOption={false}
                                onSearch={handleSearchCompanies}
                                // onChange={handleChange}
                                notFoundContent={null}
                                options={(companies || []).map((d) => ({
                                    value: d.value,
                                    label: d.text,
                                }))}
                            />
                        </Form.Item> */}
                        <Form.Item name="regType" rules={[requiredRule]} initialValue={"service-center"} >
                            <Radio.Group onChange={(e) => setRegType(e.target.value)} optionType="button" buttonStyle="solid" block style={{ whiteSpace: "nowrap" }}>
                                <Radio value="service-center">{regType === "service-center" && <CheckOutlined />} As Service Center</Radio>
                                <Radio value="service-taker">{regType === "service-taker" && <CheckOutlined />} As Service Taker</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item name="name" label={<>Name <span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]} >
                            <Input size="large" placeholder="Name" />
                        </Form.Item>
                        {regType === "service-center" && <>
                            <Row className={"w-full"}>
                                <Form.Item name="addressLine1" className={isMobile ? "w-full" : "w-[50%]"} label={<>Address Line 1 <span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]} >
                                    <Input size="large" placeholder="Address Line 2" />
                                </Form.Item>
                                <Form.Item name="addressLine2" className={isMobile ? "w-full" : "w-[50%]"} label={<>Address Line 2</>} >
                                    <Input size="large" placeholder="Address Line 2" />
                                </Form.Item>
                            </Row>
                            <Form.Item name="contactName" label={<>Contact Person <span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]} >
                                <Input size="large" placeholder="Contact Name" />
                            </Form.Item>
                        </>}
                        <Row className={"w-full"}>
                            <Form.Item name="email" className={isMobile ? "w-full" : "w-[50%]"} label={<>Email Address</>} rules={[{ type: "email", message: "Valid email required" }]} >
                                <Input inputMode="email" size="large" placeholder="Email Address" />
                            </Form.Item>
                            <Form.Item name="phone" className={isMobile ? "w-full" : "w-[50%]"} label={<>Mobile Number <span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
                                <Input inputMode="tel" size="large" placeholder="Mobile Number" />
                            </Form.Item>
                        </Row>
                        {regType === "service-taker" &&
                            <Form.Item name="gender" label={<>Gender<span style={{ color: "red", marginLeft: "2px" }}>*</span> </>} rules={[requiredRule]}>
                                <Select size="large" placeholder="Gender">
                                    <Select.Option value="male">Male</Select.Option>
                                    <Select.Option value="female">Female</Select.Option>
                                    <Select.Option value="other">Other</Select.Option>
                                </Select>
                            </Form.Item>}
                        {regType === "service-center" &&
                            <>
                                <Form.Item name="businessTypeId" label={<>Business Type<span style={{ color: "red", marginLeft: "2px" }}>*</span> </>} rules={[requiredRule]}>
                                    <Select
                                        size="large"
                                        placeholder={"Business Type"}
                                        options={businessTypes.map((x: any) => ({ label: x.name, value: x.id }))}
                                        onChange={(value) => setBusinessTypeId(value)}
                                    />
                                </Form.Item>
                                {businessTypeId === 1 &&
                                    <Form.Item name="organizationName" label={<>Organization Name</>} >
                                        <AutoComplete
                                            options={orgsSuccess ? orgsResponse.map((x: any) => ({ value: x.name })) || [] : []}
                                            onSearch={debouncedSearch}
                                            notFoundContent={orgsFetching ? <Spin size="small" /> : null}
                                        >
                                            <Input size="large" placeholder="Organization Name" />
                                        </AutoComplete>
                                    </Form.Item>}
                            </>
                        }
                        <Form.Item name="loginName" label={<>Login Name <span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[{ required: true, message: "Required" }]} >
                            <Input size="large" placeholder="Login name, email address or mobile number" prefix={<UserOutlined size={36} className="pr-1.5 text-black opacity-60" />} />
                        </Form.Item>
                        <Row className="w-full">
                            <Form.Item name="password" className={isMobile ? "w-full" : "w-[50%]"} label={<>Password <span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
                                <Password size="large" placeholder="Password" prefix={<LockOutlined size={36} className="pr-1.5 text-black opacity-60" />} />
                            </Form.Item>
                            <Form.Item name="confirmPassword" className={isMobile ? "w-full" : "w-[50%]"} label={<>Confirm password <span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule, { validator: validateConfirmPassword }]}>
                                <Password size="large" placeholder="Confirm password" prefix={<LockOutlined size={36} className="pr-1.5 text-black opacity-60" />} />
                            </Form.Item>
                        </Row>
                        <Button onClick={handleRegister} type="primary" block size="large">
                            {registerCenterResult.isLoading || registerTakerResult.isLoading ? "Please wait..." : "Register"}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default Register;
